import React from 'react';
import {
    Box,
    Paper,
    Step,
    StepConnector,
    StepLabel,
    Stepper,
    Typography,
    useMediaQuery,
    useTheme
} from '@material-ui/core';

import { WizardStep } from './types/types';
import { WizardStepIcon } from './check-icon';

interface WizardStepperProps {
    steps: WizardStep[];
    activeStep: number;
    onStepClick?: (index: number) => void;
}

export const WizardStepper: React.FC<WizardStepperProps> = ({ steps, activeStep, onStepClick }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <Paper
            elevation={0}
            style={{
                padding: isMobile ? '6px 4px' : '10px 10px',
                marginBottom: 20,
                borderRadius: 12,
                border: '1px solid #2ec4b6',
                boxShadow: 'none'
            }}>
            <Stepper
                activeStep={activeStep}
                connector={
                    <StepConnector
                        style={{
                            display: 'none'
                        }}
                    />
                }
                style={{ padding: 0, background: 'transparent' }}>
                {steps.map((step, index) => {
                    const isActive = index === activeStep;
                    const isPast = index < activeStep;

                    return (
                        <Step
                            key={step.label}
                            completed={isPast}
                            onClick={() => onStepClick?.(index)}
                            style={{
                                cursor: 'pointer',
                                borderRadius: 8,
                                flex: '1 1 0',
                                padding: isMobile ? '6px 4px' : '8px 12px',
                                background: isActive ? '#e8f8f5' : 'transparent',
                                opacity: 1
                            }}>
                            <StepLabel
                                StepIconComponent={(props) => (
                                    <WizardStepIcon {...props} icon={index + 1} />
                                )}
                                optional={
                                    !isMobile ? (
                                        <Typography
                                            style={{
                                                fontSize: 11,
                                                color: '#666',
                                                lineHeight: 1.3
                                            }}>
                                            {step.subLabel}
                                        </Typography>
                                    ) : undefined
                                }
                                style={{ width: '100%' }}>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    width="100%">
                                    <span
                                        style={{
                                            fontSize: isMobile ? 12 : 14,
                                            fontWeight: 600,
                                            fontFamily: "'DM Sans', sans-serif",
                                            color: index <= activeStep ? '#111' : '#666'
                                        }}>
                                        {step.label}
                                    </span>

                                    {!isMobile && step.icon && (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{
                                                color: isActive || isPast ? '#1eb89a' : '#ccc',
                                                fontSize: 18,
                                                lineHeight: 1,
                                                transition: 'color 0.2s',
                                                marginTop: '10px'
                                            }}>
                                            {step.icon}
                                        </Box>
                                    )}
                                </Box>
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Paper>
    );
};
